jQuery(document).ready(function () {
  jQuery("a.open-bio").click(function () {
    jQuery(this).nextAll(".bio-more").first().toggle();
    jQuery(this).toggleClass("active");
    return false;
  });

  var klaviyo_bis_interval = setInterval(function () {
    var klaviyo_bis_btn = jQuery("a.btn.klaviyo-bis-trigger").length;

    if (klaviyo_bis_btn) {
      jQuery("a.btn.klaviyo-bis-trigger").appendTo("#klaviyo-btn-wrapper");
      clearInterval(klaviyo_bis_interval);
    }
  }, 100);
});

//quick-btn-add-to-cart
$(document).ready(function () {
  $(".product-item__quick-shop-button").on("click", function () {
    $("#empty-cart-wrapper").hide();
    // $("#free-gift-progress").hide();
    $(".c-empty-cart-wrapper").hide();
    $(".c-empty-cart-wrapper").hide();
    $(".c-recommended-product-section").hide();
    $(".c-cart-compliment").hide();
    $(".js-tab-link-cart").hide();
  });
});

$(document).ready(function () {


  $(".showw, .add-to-cart, .add_to_cart").on("click", function () {
      setTimeout(function () {
        $(".js-tab-link-cart").show();
      }, 1000);
  });
});
// checkout
document.addEventListener("DOMContentLoaded", function () {
  var checkoutButton = document.getElementById("checkout-button");

  if (checkoutButton) {
    checkoutButton.addEventListener("click", function (e) {
      e.preventDefault();
      window.location.href = "/checkout";
    });
  }
});
document.querySelectorAll('.mobile-filter-form input[type="reset"]').forEach((btn) => {
  btn.addEventListener('click', () => {
    setTimeout(() => {
      // Uncheck all checkboxes and radio buttons manually
      document.querySelectorAll('.mobile-filter-panel input[type="checkbox"], .mobile-filter-panel input[type="radio"]').forEach((input) => {
        input.checked = false;
      });
    }, 10); // let native reset happen first
  });
});

// Contact form AJAX submission
document.addEventListener('DOMContentLoaded', function() {
  const contactForm = document.getElementById('contact-form');
  const successMessage = document.getElementById('contact-success-message');
  const errorMessage = document.getElementById('contact-form-errors');
  const submitButton = contactForm ? contactForm.querySelector('button[type="submit"]') : null;

  if (contactForm && submitButton) {
    // Handle form submission
    contactForm.addEventListener('submit', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // Validate form fields
      const name = document.getElementById('ContactFormName').value.trim();
      const email = document.getElementById('ContactFormEmail').value.trim();
      const message = document.getElementById('ContactFormMessage').value.trim();
      
      if (!name || !email || !message) {
        if (errorMessage) {
          errorMessage.innerHTML = '<p>Please fill in all required fields.</p>';
          errorMessage.style.display = 'block';
          errorMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return false;
      }
      
      // Show loading state
      const originalText = submitButton.textContent;
      submitButton.textContent = 'Sending...';
      submitButton.disabled = true;
      
      // Hide previous messages
      if (successMessage) successMessage.style.display = 'none';
      if (errorMessage) errorMessage.style.display = 'none';
      
      // Get form data
      const formData = new FormData(contactForm);
      
      // Submit via AJAX to contact endpoint
      fetch('/contact', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => {
        if (response.ok) {
          // Show success message
          if (successMessage) {
            successMessage.style.display = 'block';
            successMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          
          // Reset form
          contactForm.reset();
        } else {
          throw new Error('Form submission failed');
        }
      })
      .catch(error => {
        console.error('Error:', error);
        // Show error message
        if (errorMessage) {
          errorMessage.innerHTML = '<p>There was an error sending your message. Please try again.</p>';
          errorMessage.style.display = 'block';
          errorMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      })
      .finally(() => {
        // Reset button state
        submitButton.textContent = originalText;
        submitButton.disabled = false;
      });
      
      return false;
    });
  }
});

// Image Slider on Product Grid Thumbnails - Var A
function initProductImageSlider() {
  // Only run if Var A class is on body
  if (!document.body.classList.contains('c-image-slider-on-product-grid-thumbnails-VarA')) {
    return;
  }

  const productItems = document.querySelectorAll('.product-item__image-wrapper');
  
  productItems.forEach((wrapper) => {
    const imagesContainer = wrapper.querySelector('.product-item__images');
    if (!imagesContainer) return;
    
    // Get ALL product images (not just first 2)
    const allImages = imagesContainer.querySelectorAll('.product-item__image');
    
    // Only initialize if there are multiple images
    if (!allImages || allImages.length < 2) return;
    
    // Check if already initialized
    if (imagesContainer.dataset.sliderInitialized === 'true') return;
    imagesContainer.dataset.sliderInitialized = 'true';
    
    // Disable default hover behavior from theme's JavaScript
    // The theme adds 'visible' class on hover, we'll manage it manually
    imagesContainer.addEventListener('mouseover', (e) => {
      // Prevent theme's default hover behavior
      e.stopImmediatePropagation();
    }, true);
    
    imagesContainer.addEventListener('mouseout', (e) => {
      // Prevent theme's default hover behavior
      e.stopImmediatePropagation();
    }, true);
    
    let currentIndex = 0;
    const images = Array.from(allImages);
    const totalImages = images.length;
    
    // Show all images (they're hidden by default except first)
    images.forEach((img, index) => {
      if (index === 0) {
        img.style.display = 'block';
        img.style.opacity = '1';
        img.style.zIndex = '1';
        img.classList.add('visible');
      } else {
        img.style.display = 'block';
        img.style.opacity = '0';
        img.style.zIndex = '0';
        img.classList.remove('visible');
        img.classList.add('hidden');
      }
    });
    
    // Create navigation container to hold arrows and dots together
    const navContainer = document.createElement('div');
    navContainer.className = 'c-product-slider-nav-container';
    
    // Create arrow buttons
    const arrowLeft = document.createElement('button');
    arrowLeft.className = 'c-product-slider-arrows c-product-slider-arrow-left';
    arrowLeft.setAttribute('aria-label', 'Previous image');
    arrowLeft.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><rect width="15.4515" height="15.4515" rx="7.72575" transform="matrix(-1 0 0 1 15.4517 0)" fill="white"/><path d="M9.64415 4.23822C9.45152 4.04559 9.13928 4.04559 8.94665 4.23822L5.80791 7.37697C5.61528 7.5696 5.61528 7.88184 5.80791 8.07447L8.94665 11.2132C9.13928 11.4058 9.45152 11.4058 9.64415 11.2132C9.83668 11.0206 9.83675 10.7083 9.64415 10.5157L6.85416 7.72572L9.64415 4.93572C9.83675 4.74312 9.83668 4.43086 9.64415 4.23822Z" fill="#D81E5B"/></svg>';
    
    // Create pagination dots
    const dotsContainer = document.createElement('div');
    dotsContainer.className = 'c-product-slider-dots';
    
    for (let i = 0; i < totalImages; i++) {
      const dot = document.createElement('button');
      dot.className = 'c-product-slider-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('aria-label', `Go to image ${i + 1}`);
      dot.dataset.index = i;
      dotsContainer.appendChild(dot);
    }
    
    // Create arrow buttons
    const arrowRight = document.createElement('button');
    arrowRight.className = 'c-product-slider-arrows c-product-slider-arrow-right';
    arrowRight.setAttribute('aria-label', 'Next image');
    arrowRight.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><rect width="15.4515" height="15.4515" rx="7.72575" fill="white"/><path d="M5.80751 4.23822C6.00014 4.04559 6.31238 4.04559 6.50501 4.23822L9.64375 7.37697C9.83638 7.5696 9.83638 7.88184 9.64375 8.07447L6.50501 11.2132C6.31238 11.4058 6.00014 11.4058 5.80751 11.2132C5.61498 11.0206 5.61491 10.7083 5.80751 10.5157L8.5975 7.72572L5.80751 4.93572C5.61491 4.74312 5.61498 4.43086 5.80751 4.23822Z" fill="#D81E5B"/></svg>';
    
    // Append left arrow, dots, and right arrow to nav container in order
    navContainer.appendChild(arrowLeft);
    navContainer.appendChild(dotsContainer);
    navContainer.appendChild(arrowRight);
    
    // Append nav container to images container
    imagesContainer.appendChild(navContainer);
    
    // Add class to wrapper to indicate multiple images exist (for CSS)
    wrapper.classList.add('c-has-multiple-images');
    
    // Function to update active image and dots
    function updateSlider(index) {
      currentIndex = index;
      
      // Update images with smooth transition
      images.forEach((img, i) => {
        if (i === index) {
          img.style.display = 'block';
          img.classList.add('visible');
          img.classList.remove('hidden');
          img.style.opacity = '1';
          img.style.zIndex = '1';
        } else {
          img.style.display = 'block';
          img.classList.remove('visible');
          img.classList.add('hidden');
          img.style.opacity = '0';
          img.style.zIndex = '0';
        }
      });
      
      // Update dots
      const dots = dotsContainer.querySelectorAll('.c-product-slider-dot');
      dots.forEach((dot, i) => {
        if (i === index) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    }
    
    // Arrow click handlers
    arrowLeft.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const newIndex = currentIndex === 0 ? totalImages - 1 : currentIndex - 1;
      updateSlider(newIndex);
    });
    
    arrowRight.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const newIndex = currentIndex === totalImages - 1 ? 0 : currentIndex + 1;
      updateSlider(newIndex);
    });
    
    // Dot click handlers
    dotsContainer.querySelectorAll('.c-product-slider-dot').forEach((dot) => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const index = parseInt(dot.dataset.index);
        updateSlider(index);
      });
    });
    
    // Swipe gesture for mobile
    let touchStartX = 0;
    let touchEndX = 0;
    let isSwiping = false;
    
    imagesContainer.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
      isSwiping = true;
    }, { passive: true });
    
    imagesContainer.addEventListener('touchmove', (e) => {
      if (isSwiping) {
        touchEndX = e.changedTouches[0].screenX;
      }
    }, { passive: true });
    
    imagesContainer.addEventListener('touchend', (e) => {
      if (!isSwiping) return;
      isSwiping = false;
      
      const swipeThreshold = 50;
      const diff = touchStartX - touchEndX;
      
      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          // Swipe left - next image
          const newIndex = currentIndex === totalImages - 1 ? 0 : currentIndex + 1;
          updateSlider(newIndex);
        } else {
          // Swipe right - previous image
          const newIndex = currentIndex === 0 ? totalImages - 1 : currentIndex - 1;
          updateSlider(newIndex);
        }
      }
    }, { passive: true });
    
    // Keyboard navigation
    wrapper.addEventListener('keydown', (e) => {
      if (document.activeElement === wrapper || wrapper.contains(document.activeElement)) {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          const newIndex = currentIndex === 0 ? totalImages - 1 : currentIndex - 1;
          updateSlider(newIndex);
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          const newIndex = currentIndex === totalImages - 1 ? 0 : currentIndex + 1;
          updateSlider(newIndex);
        }
      }
    });
    
    // Initialize with first image
    updateSlider(0);
  });
}

// Initialize on page load and after dynamic content loads
function initSliderWhenReady() {
  if (document.body.classList.contains('c-image-slider-on-product-grid-thumbnails-VarA')) {
    initProductImageSlider();
  }
}

// Run on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  initSliderWhenReady();
});

// Run after Intelligems is ready
window.addEventListener('ig:ready', () => {
  setTimeout(initSliderWhenReady, 100);
});

// Run on AJAX content loads (for infinite scroll, filters, etc.)
const observer = new MutationObserver(() => {
  if (document.body.classList.contains('c-image-slider-on-product-grid-thumbnails-VarA')) {
    initProductImageSlider();
    initVarAQuickShopHandler();
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

// Var A Quick Shop Handler - Ensure custom-quick opens modal, not cart drawer
function initVarAQuickShopHandler() {
  // Only run if Var A class is on body
  if (!document.body.classList.contains('c-image-slider-on-product-grid-thumbnails-VarA')) {
    return;
  }

  // Handle custom-quick button clicks - ensure it opens the modal popup, not cart drawer
  document.querySelectorAll('.product-item__details-wrapper .product-item__quick-shop-button.custom-quick').forEach((button) => {
    // Check if handler already added to prevent duplicates
    if (button.hasAttribute('data-var-a-handler-added')) {
      return;
    }
    button.setAttribute('data-var-a-handler-added', 'true');
    
    // Remove the inline onclick to add our own handler that prevents cart drawer from opening
    button.removeAttribute('onclick');
    
    // Add click handler that opens the modal, preventing cart drawer from opening
    button.addEventListener('click', function(e) {
      // Stop all event propagation immediately to prevent cart drawer from opening
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      // Get the product ID from the button
      const productId = this.getAttribute('data-product');
      if (!productId) return;
      
      // Open the modal directly
      document.querySelectorAll('.modal-overlay-quick').forEach(function(modal) {
        if (modal.getAttribute('data-product') == productId) {
          modal.style.display = "block";
          modal.classList.add("active");
          document.body.classList.add('model_overflow');
        }
      });
    }, true); // Use capture phase to ensure it runs before other handlers (like cart drawer)
  });
}

// Initialize Quick Shop handler on page load
document.addEventListener('DOMContentLoaded', () => {
  if (document.body.classList.contains('c-image-slider-on-product-grid-thumbnails-VarA')) {
    initVarAQuickShopHandler();
  }
});

// Re-initialize after Intelligems is ready
window.addEventListener('ig:ready', () => {
  setTimeout(() => {
    if (document.body.classList.contains('c-image-slider-on-product-grid-thumbnails-VarA')) {
      initVarAQuickShopHandler();
    }
  }, 100);
});

// Watch for when the Var A class is added dynamically (in case Intelligems loads late)
const bodyObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
      if (document.body.classList.contains('c-image-slider-on-product-grid-thumbnails-VarA')) {
        // Small delay to ensure buttons are in the DOM
        setTimeout(() => {
          initVarAQuickShopHandler();
        }, 50);
      }
    }
  });
});

// Start observing body class changes
if (document.body) {
  bodyObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    bodyObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
  });
}
